export enum FormTemplateSectionTypeEnum {
    Standard = 1,
    PersonalInformation = 2,
}
